module.exports = __webpack_public_path__ + "static/media/img-mygood-screen@2x.22c83e70.png";